
export enum PageType {
    AUTHOR = 'author',
    CATEGORY = 'category',
    ERROR = 'error',
    INDEX = 'index',
    ONE_DIGITAL = 'one-digital',
    PAGE = 'page',
    SEARCH = 'search',
    STORY = 'story',
    TAG = 'tag'
}
